import { useContext, useMemo } from "react";
import { ConfiguratorContext } from "../../contexts/ConfiguratorContext";
import { DASHBOARD_DISPLAY_TOTAL_AMOUNT_DUE_KEY } from "../constants/Configurator.constants";
import { findInArray, parseConfigBoolean } from "../utils/utility-functions";

/**
 * Whether the client has asked for the total past due amount rather than the single next
 * payment due (US-986802). Absent or No keeps today's screens exactly as they are, which is
 * what every client that has never answered the question sees.
 */
export const useTotalAmountDueConfig = () => {
  const { edittedFields } = useContext(ConfiguratorContext);

  return useMemo(() => {
    const displayField = findInArray(
      edittedFields,
      "key",
      DASHBOARD_DISPLAY_TOTAL_AMOUNT_DUE_KEY,
    );

    return {
      showTotalAmountDue: parseConfigBoolean(displayField?.value),
    };
  }, [edittedFields]);
};
